export default __webpack_public_path__ + "static/media/server-and-networking-notes.82e68d02.png";